import React from 'react';
import styled from 'styled-components';
import { TablePadrão, Td, Tr } from '../../../../components/develop-nilton-components/TablePadrão';
import { Pagination } from '../../../../components/Pagination';
import { SpinnerLoading } from '../../../../components/SpinnerLoading';
import { TypeTableGeral } from '../types';
import { TbodyTable } from './TbodyTable';

export function TableGeral({
  egresses, handleSetEgresses, load,
}:TypeTableGeral) {
  const headWidth = ["5%", "45%", "25%", "25%"];
  const thead = ["#", "Nome", "Status", "Opções"];
  return (
    <div>
      <TablePadrão thead={thead} headWidth={headWidth}>
        {load && (
        <Tr>
          <Td width="100%">
            <div className="d-flex justify-content align-items" data-testid="load">
              <SpinnerLoading />
            </div>
          </Td>
        </Tr>
        )}
        {egresses?.data.map((item, i) => (
          <TbodyTable
            egresse={item}
            key={item.id}
            index={i + 1}
            headWidth={headWidth}
          />
        ))}
      </TablePadrão>
      {egresses && (
      <Pagination
        meta={egresses?.meta}
        setPage={handleSetEgresses}
      />
      )}
    </div>
  );
}
